// extracted by mini-css-extract-plugin
module.exports = {"moduleRoot":"PageContact_moduleRoot__25Q8n","flexCol":"PageContact_flexCol__12McF","bregtFoto":"PageContact_bregtFoto__2zQ_x","addressColumn":"PageContact_addressColumn__2sJR5"};